import { types } from "./constants";

export function getProductsRequest() {
  return {
    type: types.GET_PRODUCTS_REQUEST,
  };
}

export function getProductsSuccess(data) {
  return {
    type: types.GET_PRODUCTS_SUCCESS,
    payload: { data },
  };
}

export function getProductsFail(error) {
  return {
    type: types.GET_PRODUCTS_FAIL,
    payload: { error },
  };
}

export function createOrderRequest(productName) {
  return {
    type: types.CREATE_ORDER_REQUEST,
    payload: { productName },
  };
}

export function createOrderSuccess(data) {
  return {
    type: types.CREATE_ORDER_SUCCESS,
    payload: { data },
  };
}

export function createOrderFail(error) {
  return {
    type: types.CREATE_ORDER_FAIL,
    payload: { error },
  };
}

export function captureOrderRequest(orderId) {
  return {
    type: types.CAPTURE_ORDER_REQUEST,
    payload: { orderId },
  };
}

export function captureOrderSuccess(data) {
  return {
    type: types.CAPTURE_ORDER_SUCCESS,
    payload: { data },
  };
}

export function captureOrderFail(error) {
  return {
    type: types.CAPTURE_ORDER_FAIL,
    payload: { error },
  };
}

export function selectProduct(product) {
  return {
    type: types.SELECT_PRODUCT,
    payload: { product },
  };
}

export function clearSelectedProduct() {
  return {
    type: types.CLEAR_SELECTED_PRODUCT,
  };
}
